const authError = "Authentication error!";
const friendlyAuthMsg = "Session timeout! Please log in again to continue!";

export default function handleError(error, setToken){
    if (error === authError){
        alert(friendlyAuthMsg);
        setToken(null);
    }
    else alert(`Encountered an error: ${error}`);
}